import styles from "./Checkbox.module.css";
import classNames from "classnames";
import type { JSX, InputHTMLAttributes, PropsWithChildren, ChangeEvent } from "react";

import {} from "react";
import { CheckIcon } from "./CheckIcon";

type CheckboxProps = PropsWithChildren<{
  isChecked: boolean;
  className?: string;
}> &
  InputHTMLAttributes<HTMLInputElement>;

const Checkbox = (props: CheckboxProps): JSX.Element => {
  const { isChecked = false, id, name, className, onChange, children } = props;

  const labelClassNames = classNames(styles.label, className);
  const controlClassNames = classNames(styles.control, { [styles.isChecked]: isChecked });
  const checkIconClassNames = classNames(styles.checkmark, {
    [styles.isChecked]: isChecked,
  });

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    if (onChange !== undefined) {
      onChange(evt);
    }
  };

  return (
    <label id={id} className={labelClassNames}>
      <input
        type="checkbox"
        id={`checkbox-${name}`}
        name={name}
        onChange={handleChange}
        className={styles.hiddenInput}
        checked={isChecked}
      />
      <div aria-hidden className={controlClassNames}>
        {isChecked && <CheckIcon className={checkIconClassNames} />}
      </div>
      {children}
    </label>
  );
};

export { Checkbox };
